/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ApiIdpSubmissionDirectDeletePost$Params {
  body?: Array<string>;
}

export function apiIdpSubmissionDirectDeletePost(
  http: HttpClient,
  rootUrl: string,
  params?: ApiIdpSubmissionDirectDeletePost$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiIdpSubmissionDirectDeletePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(rb.build({ responseType: 'text', accept: '*/*', context }))
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      }),
    );
}

apiIdpSubmissionDirectDeletePost.PATH = '/api/idp/submissions-direct/delete';
